module.exports = __webpack_public_path__ + "static/media/profilePlaceholder.68c5665a.svg";